import { getHighestEdition } from 'onboarding-scopes';
import { HubEdition } from 'onboarding-scopes/scopeConstants';
import { useScopes } from './auth';
export const useTaskAssignmentAudience = () => {
  const scopes = useScopes();
  const tier = getHighestEdition(scopes);
  const isInAudience = [HubEdition.PRO, HubEdition.STARTER].includes(tier);
  return isInAudience;
};